import { Duration, formatDuration, secondsInDay, secondsInHour, secondsInMinute, secondsToHours, secondsToMinutes } from 'date-fns';

export const formatResponseDelay = (seconds: number = secondsInMinute * 15): [string, string] => {
  let duration: Duration = seconds ? { seconds } : { minutes: 15 };
  if (seconds >= secondsInDay) {
    duration = { days: Math.min(Math.floor(seconds / secondsInDay), 4) };
  } else if (seconds >= secondsInHour) {
    duration = { hours: secondsToHours(seconds) };
  } else if (seconds >= secondsInMinute) {
    duration = { minutes: secondsToMinutes(seconds) };
  }
  return formatDuration(duration, {
    locale: {
      formatDistance: (token, count) => {
        switch (token) {
          case 'xDays':
            return count + ' д';
          case 'xHours':
            return count + ' ч';
          case 'xMinutes':
            return count + ' мин';
          case 'xSeconds':
            return count + ' сек';
          default:
            return count;
        }
      },
    },
  }).split(' ', 2) as [string, string];
};
